import { useNavigate, useParams } from "react-router";
import { Grid, Card, Paper } from "@mui/material";
// import Header from "../../components/Reusable/ManageComponents/Header";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { GET_LOCATION } from "../../features/graphql/query/location/GetLocation";
import { useEffect, useState } from "react";
import { useLocation } from "../../context/LocationContext/LocationProvider";
// import { LocationForm, LocationFormSchema } from "ft-shared-graphql/components/Forms";
// import { CustomFieldTable } from "ft-shared-graphql/components/Tables"
import { EDIT_LOCATION_MUTATION } from "ft-shared-graphql";

import { ApiValidationError, FormSubmitCallback, mapApiFieldValidationErrors } from "ui";
import { EditLocationMutation, EditLocationMutationVariables, Location } from "../../__generated__/graphql";
import { useAnswerContext } from "../../context/AnswerContext";
import { HeaderActionType, useManageModal, Header, LoadingWrapper } from "ui";
import { Description, Group, Person, QuestionAnswer } from "@mui/icons-material";
interface ManageLocationPageProps {
    onBack: () => void;
}

export default function ManageLocationPage({ onBack }: ManageLocationPageProps) {
    const { id } = useParams()
    const navigate = useNavigate()
    const { openModal } = useManageModal();
    const { location, setLocation } = useLocation()
    const [editLocation] = useMutation<EditLocationMutation, EditLocationMutationVariables>(EDIT_LOCATION_MUTATION);
    const [fetchLocation, { loading, data }] = useLazyQuery(GET_LOCATION)
    const { setAnswerInfo, setId } = useAnswerContext()
    useEffect(() => {
        if (!location) {
            fetchLocation({ variables: { id } })
        }
        if (data?.location) {
            setLocation(data.location)
        }
    }, [location, data])
    // const handleEditLocationSubmission: FormSubmitCallback<LocationFormSchema> = async (values: any):
    //     Promise<ReturnType<FormSubmitCallback>> => {
    //     const input = {
    //         id: id!,
    //         name: values.name,
    //         streetLineOne: values.streetLineOne,
    //         streetLineTwo: values.streetLineTwo ?? null,
    //         city: values.city,
    //         state: values.state,
    //         postalCode: values.postalCode,
    //         country: values.country
    //     }
    //     const response = await editLocation({
    //         variables: { input }
    //     });

    //     if (response.data?.editLocation.errors) {
    //         const validationError = response.data.editLocation.errors
    //             .find(e => e.__typename === "ValidationError") as ApiValidationError;
    //         const fieldErrors = validationError
    //             ? mapApiFieldValidationErrors(validationError)
    //             : null;

    //         return fieldErrors;
    //     }
    //     const replace = {
    //         ...response.data?.editLocation.location
    //     } as Location
    //     setLocation(replace)
    //     openModal({ type: "SAVED_CHANGES", cancelButtonLabel: "Close" })
    // }
    const handleViewSessions = () => {
        navigate(`/location/${id}/sessions`)
    }
    const handleViewAnswers = () => {
        // handleContent(SAMPLE_SLIDE_IN)
        // setAnswerInfo((prevState: any) => {
        //     return {
        //         ...prevState,
        //         answerQueryType: "locationAnswers"
        //     }
        // })
        // setId(id!)
        // navigate(`/location/${id}/answers`)
    }
    // const [testVal, setTestVal] = useState<number>(0);
    const handleManageStaffAtLocation = () => {
        navigate(`/location/${id}/manage/staff`)
    }
    const handleManageStudentsAtLocation = () => {
        navigate(`/location/${id}/manage/students`)
    }
    const headerActions: HeaderActionType[] = [{
        name: "View Answers",
        icon: <QuestionAnswer />,
        action: handleViewAnswers,
        // isHidden: testVal < 1
    }, {
        name: "View Sessions",
        icon: <Description />,
        action: handleViewSessions
    }, {
        name: "Manage Staff At Location",
        icon: <Person />,
        action: handleManageStaffAtLocation
    },
        // {
        //     name: "Manage Students At Location",
        //     icon: <Group />,
        //     action: handleManageStudentsAtLocation
        // }
    ]

    const subtitle = `Total Staff Users: ${location?.totalStaff ?? 'N/A'};\n\n Total Students: ${location?.totalStudents ?? "N/A"}`
    return (
        <LoadingWrapper loading={!location}>
            <Card elevation={4}
                style={{
                    width: "100%",
                    display: "flex", padding: "16px", height: "auto"
                }}>

                <Grid container spacing={2}>
                    <Grid size={12}>
                        <Header title={location?.name ?? ""} onBack={onBack}
                            subtitle={subtitle}
                            headerActions={headerActions}
                        />
                    </Grid>
                    <Grid size={6} sx={{ padding: 0 }}>
                        {/* <LocationForm
                            readonly={false}
                            initialValues={{
                                name: location?.name ?? '',
                                streetLineOne: location?.streetLineOne ?? '',
                                streetLineTwo: location?.streetLineTwo ?? '',
                                city: location?.city ?? '',
                                state: location?.state ?? '',
                                postalCode: location?.postalCode ?? '',
                                country: location?.country ?? ''
                            }}
                            onSubmit={handleEditLocationSubmission}
                            onCancel={() => { console.log("cancell") }}
                        /> */}
                    </Grid>
                    <Grid size={6}>
                        <Paper component="div" variant="outlined" sx={{ marginTop: "32px" }}>
                            {/* <CustomFieldTable customfields={location?.customFields ?? []} /> */}
                        </Paper>
                    </Grid>

                </Grid>
            </Card>
        </LoadingWrapper>
    )
}